export default __webpack_public_path__ + "static/Alisha Outridge-c58852735c15f341ca05b48d5cbd5939.jpg";